import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
var n = {
	inline: !1,
	content: "(hardBreak | text | inline)*",
	attrs: t({ type: { default: "code" } }),
	defining: !0,
	group: "block",
	parseDOM: [{ tag: "pre" }],
	toDOM() {
		return [
			"pre",
			{ class: `${e.code}` },
			0
		];
	},
	marks: ""
};
//#endregion
export { n as codeBlockSpec };
